import useRequest from '@hooks/useRequest';
import { IOperadora } from '@model/Operadora';
import React from 'react';

const controller = "Operadora";

export function useOperadoraService () {
    const _request = useRequest();

    const listarAtivas = React.useCallback(() => {
        return _request.get<IOperadora[]>(`${controller}/ListarAtivas`);
    }, [_request]);

    return React.useMemo(() => ({
        listarAtivas
    }), [listarAtivas])
}